// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
}

.content-container {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.time-container {
  display: flex;
  flex-direction: column;
  background: rgba(239, 239, 239, 0.5411764706);
  padding: 5px 10px;
  border-radius: 8px;
  gap: 2px;
}
.time-container .meeting-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-container .meeting-time .start-end-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.time-container .meeting-time .start-end-container div {
  display: flex;
  align-items: center;
}
.time-container .meeting-time .start-end-container div span {
  font-weight: 600;
  flex: 0.5;
  font-size: 13px;
  color: #888;
  margin: 0;
  padding: 0;
}
.time-container .meeting-time .start-end-container div ion-chip {
  display: flex;
  justify-content: center;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
}
.time-container .duration {
  display: flex;
  align-items: center;
  gap: 5px;
}
.time-container .duration span {
  display: flex;
  font-size: 13px;
  align-items: center;
  font-weight: 600;
  color: #888;
  gap: 5px;
}
.time-container .duration span ion-icon {
  color: #ed143d;
  font-size: 16px;
}
.time-container .duration ion-chip {
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1.2px;
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime::part(time-button) {
  background: #fff9f9;
  border: 2px solid #ed143d;
  font-weight: 600;
}

ion-datetime.disabled-time::part(time-button) {
  pointer-events: none;
  opacity: 0.3;
}

ion-button.check-availability-btn {
  --border-color: #ed143d;
  --color: #ed143d;
  --border-radius: 10px;
  --border-width: 1.5px;
  --background: transparent;
  --background-activated: transparent;
  --color-activated: #ed143d;
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  margin-top: 4px;
  display: flex;
}

ion-note {
  display: flex;
  gap: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/propose-new-time/propose-new-time.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;AACR;AACQ;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AACV;AAEQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAV;AAME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJJ;AAMI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AAJN;AAMM;EACE,cAAA;EACA,eAAA;AAJR;AAQI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AANN;;AAWA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AARF;;AAWA;EACE,oBAAA;EACA,YAAA;AARF;;AAWA;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AARF;;AAWA;EACE,aAAA;EACA,YAAA;AARF","sourcesContent":[":host {\n  height: 100%;\n}\n\n.content-container {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.time-container {\n  display: flex;\n  flex-direction: column;\n  background: #efefef8a;\n  padding: 5px 10px;\n  border-radius: 8px;\n  gap: 2px;\n\n  .meeting-time {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .start-end-container {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      div {\n        display: flex;\n        align-items: center;\n\n        span {\n          font-weight: 600;\n          flex: 0.5;\n          font-size: 13px;\n          color: #888;\n          margin: 0;\n          padding: 0;\n        }\n\n        ion-chip {\n          display: flex;\n          justify-content: center;\n          border-radius: 12px;\n          font-weight: 700;\n          font-size: 13px;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  .duration {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    span {\n      display: flex;\n      font-size: 13px;\n      align-items: center;\n      font-weight: 600;\n      color: #888;\n      gap: 5px;\n\n      ion-icon {\n        color: #ed143d;\n        font-size: 16px;\n      }\n    }\n\n    ion-chip {\n      border-radius: 12px;\n      font-weight: 700;\n      font-size: 13px;\n      letter-spacing: 1.2px;\n    }\n  }\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  box-shadow: none;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-datetime::part(time-button) {\n  background: #fff9f9;\n  border: 2px solid #ed143d;\n  font-weight: 600;\n}\n\nion-datetime.disabled-time::part(time-button) {\n  pointer-events: none;\n  opacity: 0.3;\n}\n\nion-button.check-availability-btn {\n  --border-color: #ed143d;\n  --color: #ed143d;\n  --border-radius: 10px;\n  --border-width: 1.5px;\n  --background: transparent;\n  --background-activated: transparent;\n  --color-activated: #ed143d;\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 4px;\n  display: flex;\n}\n\nion-note {\n  display: flex;\n  gap: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
